"use client";

import { ReactNode } from "react";
import { Provider } from "react-redux";
import { persistor, store } from "@/lib/redux/store";
import { PersistGate } from "redux-persist/integration/react";
import { SnackbarProvider } from "@/context/SnackbarContext";
import { Authenticator } from "@aws-amplify/ui-react";
import { Amplify } from "aws-amplify";
import awsconfig from "@/lib/auth/config";

Amplify.configure(awsconfig);

export function Providers({ children }: { children: ReactNode }) {
  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <Authenticator.Provider>
          <SnackbarProvider>{children}</SnackbarProvider>
        </Authenticator.Provider>
      </PersistGate>
    </Provider>
  );
}
